import { FormNames, IFormDefinition } from 'models/Form/FormModels'
import { AppLinks } from 'enviroment/AppLinks'
import { collectPersonalIdFields } from './CollectPersonalIdFields'

export const collectPersonalIdForm: IFormDefinition = {
   name: FormNames.CollectPersonalIdForm,
   fields: collectPersonalIdFields,
   labelTextContentPath: "collectPersonalIdFormPage.label",
   descriptionTextContentPath: "collectPersonalIdFormPage.description",
   urlPath: AppLinks.trastiCollectPersonalIdForm,
   nextStepUrlPath: AppLinks.waiting,
   canStepBack: true,
   previousStepUrlPath: AppLinks.chooseVerificationMethod,
   subbmitButtonTextContentPath: "collectPersonalIdFormPage.subbmitButtonText"
}